import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import './facebook-button-error-message.scss';

applyTranslations(require('./facebook-button-error-message.i18n.json'));

interface Props {
  message: string,
  isCentered?: boolean
}

const MSG_KEY = 'facebook_button_error_message';

const FacebookButtonErrorMessage: React.FC<Props> = ({
  message,
  isCentered
}): JSX.Element => {
  const containerClasses = classnames('facebook-button-error-message', {
    'facebook-button-error-message--centered': Boolean(isCentered)
  });

  return (
    <div className={containerClasses}>
      <div className="facebook-button-error-message__error">
        {message}
      </div>
      <div
        className="facebook-button-error-message__help"
        dangerouslySetInnerHTML={{
          __html: sanitizeGenericHtml(__t(`${MSG_KEY}.help`))
        }}
      />
    </div>
  );
};

export default FacebookButtonErrorMessage;
